@if (error()) {
  <div class="cg-admin-alert cg-admin-alert--error">{{ error() }}</div>
}

<div class="cg-admin-form-grid cg-admin-form-grid--2">
  <label class="cg-admin-field">
    <span class="cg-admin-field__label">Version number</span>
    <input
      class="cg-input"
      [ngModel]="form().versionNumber"
      (ngModelChange)="patch({ versionNumber: $event })"
      placeholder="e.g. 2.8.0"
    />
  </label>

  <label class="cg-admin-field">
    <span class="cg-admin-field__label">Build number</span>
    <input
      class="cg-input"
      [ngModel]="form().buildNumber"
      (ngModelChange)="patch({ buildNumber: $event })"
      placeholder="e.g. 2026.07.09"
    />
  </label>

  <label class="cg-admin-field">
    <span class="cg-admin-field__label">Release date</span>
    <input
      class="cg-input"
      type="date"
      [ngModel]="form().releaseDate"
      (ngModelChange)="patch({ releaseDate: $event })"
    />
  </label>

  <label class="cg-admin-field">
    <span class="cg-admin-field__label">Display order</span>
    <input
      class="cg-input"
      type="number"
      min="0"
      [ngModel]="form().displayOrder"
      (ngModelChange)="patch({ displayOrder: +$event })"
    />
  </label>

  <label class="cg-admin-field cg-admin-field--full">
    <span class="cg-admin-field__label">Release title</span>
    <input
      class="cg-input"
      [ngModel]="form().title"
      (ngModelChange)="patch({ title: $event })"
      placeholder="e.g. July 2026 Platform Update"
    />
  </label>

  <label class="cg-admin-field cg-admin-field--full">
    <span class="cg-admin-field__label">Short summary</span>
    <textarea
      class="cg-input cg-textarea"
      rows="3"
      [ngModel]="form().shortSummary"
      (ngModelChange)="patch({ shortSummary: $event })"
      placeholder="Brief overview shown at the top of the release"
    ></textarea>
  </label>

  <label class="cg-admin-field">
    <span class="cg-admin-field__label">Release status</span>
    <select
      class="cg-select"
      [ngModel]="form().status"
      (ngModelChange)="patch({ status: $event })"
    >
      <option value="DRAFT">Draft</option>
      <option value="PUBLISHED">Published</option>
    </select>
  </label>
</div>

<app-release-update-list
  [items]="form().updateItems"
  (itemsChange)="patch({ updateItems: $event })"
/>

<div class="rn-form__actions">
  <app-admin-button variant="cancel" type="button" (click)="cancel.emit()">Cancel</app-admin-button>
  <app-admin-button variant="primary" type="button" [disabled]="saving()" (click)="save.emit()">
    {{ saving() ? 'Saving…' : 'Save release' }}
  </app-admin-button>
</div>
